import React from 'react';

import {
  SearchContainer,
  Wrapper,
  SearchHead,
  View,
  FilterWrapper,
  SearchDetail,
} from './styles';
import FilterModalMobile from '../../FilterModal/FilterModalMobile';
import Search from '../../Search/Search';
import MultiSelect from '../../../Components/MultiSelect/MultiSelect';
import ToggleSwitch from '../../../../../CommonComponents/ToggleSwitch/ToggleSwitch';
import FilterModal from '../../../../../assets/icons/filter-filled-tool-symbol.svg';
import { amountFormatter } from '../../../utils';
import PropTypes from 'prop-types';

const SearchMobile = ({
  options,
  filters,
  changeState,
  filterType,
  searched,
  restored,
  sorted,
  value,
  selectedVal,
  clicked,
  reset,
  closed,
  selected,
  mobileViewHandler,
  mobileViewFlag,
  assetsDetails,
}) => {
  return (
    <SearchContainer>
      <Wrapper Search>
        <Search
          placeholder='Search by Client Name or Fund Name or Acc. Number'
          searched={searched}
          restored={restored}
        />
      </Wrapper>
      <Wrapper Sort>
        <p>Sort By</p>
        <MultiSelect
          options={options}
          value={value}
          selectedVal={selectedVal}
          sorted={(value) => sorted(value)}
          defaultValue={'lastNameAsc'}
          mode='default'
        />
      </Wrapper>
      <Wrapper Filter AlignCenter>
        <View secondary>
          <SearchHead>View</SearchHead>
          <ToggleSwitch filterType={filterType} changeState={changeState} />
        </View>
        <Wrapper AlignCenter>
          <SearchHead>Filter</SearchHead>
          <FilterWrapper
            alt='Filter'
            src={FilterModal}
            onClick={mobileViewHandler}
          />
        </Wrapper>
      </Wrapper>
      {mobileViewFlag && (
        <FilterModalMobile
          reset={reset}
          selected={selected}
          filters={filters}
          closed={closed}
          mobileViewHandler={mobileViewHandler}
        />
      )}
      <SearchDetail>
        Displaying <span>{assetsDetails && assetsDetails.accounts}</span>{' '}
        accounts, assets worth with{' '}
        <span> {amountFormatter(assetsDetails.assets)}</span>
      </SearchDetail>
    </SearchContainer>
  );
};
SearchMobile.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  filters: PropTypes.arrayOf(PropTypes.object),
  changeState: PropTypes.func,
  filterType: PropTypes.string,
  searched: PropTypes.func,
  restored: PropTypes.func,
  sorted: PropTypes.func,
  value: PropTypes.string,
  selectedVal: PropTypes.string,
  clicked: PropTypes.func,
  reset: PropTypes.func,
  closed: PropTypes.func,
  selected: PropTypes.func,
  mobileViewHandler: PropTypes.func,
  mobileViewFlag: PropTypes.bool,
  assetsDetails: PropTypes.object,
};
export default SearchMobile;
